"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type EmptyProjectsIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useEmptyProjectsIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/empty-projects.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/projects-empty.svg"
    : "/assets/empty-projects.svg";
}

export function EmptyProjectsIllustration({
  className,
  alt = "",
  width = 215,
  height = 140,
  ...props
}: EmptyProjectsIllustrationProps) {
  const src = useEmptyProjectsIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-[140px] w-[215px]", className)}
      {...props}
    />
  );
}
